export enum TENANT_SETTINGS {
  REFERRALS = 'use_referrals',
  USES_CONTRACTS = 'uses_contracts',
  OVERLAPPING_EVENTS = 'overlapping_events',
  INTEGRATION_GOOGLE_OAUTH = 'use_integrations_authentication_google_oauth',
  INTEGRATION_SIS_SCHOOLDAY_ONEROSTER = 'use_integrations_sis_schoolday_oneroster',
  UTILIZATION_TRACKING = 'use_utilization_tracking',
  CONTRACT_INHERITANCE = 'use_contract_inheritance',
  USES_TENANT_ASSESSMENTS = 'use_tenant_assessments',
  USES_REFERRAL_BUILDER = 'use_referral_builder',
  MESSAGE_CENTER = 'use_message_center',
  USE_INTEGRATION_SIS_SCHOOLDAY_ONEROSTER = 'use_integrations_sis_schoolday_oneroster',
  USE_PEOPLE_TO_BE_ARCHIVED = 'use_people_to_be_archived',
  MEDICAID_BILLING = 'use_medicaid_billing',
  USE_SP_SCHOOL_AUTOMATCHING = 'use_sp_school_automatching',
  USE_AUTOMATCHING_FOR_UNASSIGNED = 'use_automatching_for_unassigned',
  USE_AUTOMATCHING_FOR_REFERRALS = 'use_automatching_for_referrals',
}

export enum OAUTH_PROVIDER_SLUG {
  GOOGLE = 'google.oauth',
}

export enum SIS_PROVIDER_SLUG {
  SCHOOLDAY = 'sis.schoolday',
}
